var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "message-card",
    on: {
      click: function click($event) {
        return _vm.$emit("click", _vm.normalizedCard);
      }
    }
  }, [_c("div", {
    staticClass: "card-header"
  }, [_vm._m(0), _c("div", {
    staticClass: "card-main"
  }, [_c("h4", {
    staticClass: "card-title"
  }, [_vm._v(_vm._s(_vm.normalizedCard.title || "系统通知"))]), _vm.normalizedCard.summary ? _c("p", {
    staticClass: "card-summary"
  }, [_vm._v(_vm._s(_vm.normalizedCard.summary))]) : _vm._e()]), _vm.tagText ? _c("span", {
    staticClass: "card-tag"
  }, [_vm._v(_vm._s(_vm.tagText))]) : _vm._e()]), _vm._m(1)]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "card-icon-wrap"
  }, [_c("i", {
    staticClass: "el-icon-document card-icon"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "card-footer"
  }, [_c("span", [_vm._v("查看详情")]), _c("i", {
    staticClass: "el-icon-arrow-right"
  })]);
}];
render._withStripped = true;
export { render, staticRenderFns };